<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('tv.Header') }}</h2>

            </div>
        </div>
        <div id="image_holder" class="imageHolder" style="height:600px; display:flex">
            <div class="video_player">
                <kendo-mediaplayer ref="mediaplayer"
                                   v-on:kendoready="kendoready"
                                   v-on:timechange="timechange"
                                   style="height:600px;"
                                   :media-title="$t('tv.Title')"
                                   :media-source="url">
                </kendo-mediaplayer>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';
    import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
    import { MediaPlayer } from '@progress/kendo-mediaplayer-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-datasource': DataSource,
            'kendo-mediaplayer': MediaPlayer
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].BaseUrl + "/Videos/wdrlokalzeitruhr18062007.mp4"
        },
        methods: {
            kendoready: function () {
                console.log('kendoready');
            },
            timechange: function () {
                console.log('timechange');
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>